module.exports = __webpack_public_path__ + "img/mission-gfp-2030-banner.jpg?271184265056eda10bfbd01623374698";